import { render } from "./ServiceItem.vue?vue&type=template&id=c726dd96"
import script from "./ServiceItem.vue?vue&type=script&lang=js"
export * from "./ServiceItem.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/Home/components/ServiceItem.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c726dd96"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c726dd96', __exports__)) {
    console.log('reload')
    api.reload('c726dd96', __exports__)
  }
  
  module.hot.accept("./ServiceItem.vue?vue&type=template&id=c726dd96", () => {
    console.log('re-render')
    api.rerender('c726dd96', render)
  })

}


export default __exports__